module.exports = __webpack_public_path__ + "static/media/alarm.2a3504c5.svg";